export default {
  'Normal routing': 'Normal routing',
  'Member center menu contents': 'Member center menu directory ',
  'Member center menu items': 'Member Center menu items',
  'English name': 'English name',
  'Web side routing path': 'Web side routing path'
}
